import contact from './contact';
// eslint-disable-next-line
import { TimelineMax, TweenMax, Linear } from 'gsap'
import * as ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic'


// eslint-disable-next-line
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default {
  init() {
    contact.handleContactForm()
    this.parallaxImage();
    this.slider();
    this.appendUTMQueryParamsToCtas();
    this.playVideoOnScroll();
  },
  parallaxImage() {
    const controller = new ScrollMagic.Controller();

    const parallaxImages = $('.flexible-content--parallax-image');

    $(parallaxImages).each(function (a,b) {
      new ScrollMagic.Scene({triggerElement: b, duration: '200%', offset: 0, triggerHook: 'onEnter'})
        .setTween($(b).find('div'), {y: '80%', ease: Linear.easeNone})
        .addTo(controller);
    })
  },
  slider() {
    $('.slider').each(function() {
      $(this).slick({
        dots: $(this).find('.slide').length > 2,
        autoplay: $(this).attr('data-autoplay') == 1,
        autoplaySpeed: $(this).attr('data-speed') ? $(this).attr('data-speed') : 3000,
        arrows: $(this).attr('data-arrows') == 1,
        nextArrow: '<div class="cta cta-white-primary-border next" aria-label="Next"><button type="button"><span></span></button></div>',
        prevArrow: '<div class="cta cta-white-primary-border prev" aria-label="Previous"><button type="button"><span></span></button></div>',
      });
    });
  },
  appendUTMQueryParamsToCtas() {
    const queryParams = window.location.href.toString().split('?');

    if (queryParams[1] === undefined) {
      return;
    }

    const split = queryParams[1].split('&')
    let parameterAppendString = '';

    Object.keys(split).forEach(key => {
      if (split[key].startsWith('utm')){
        console.log(typeof split[key]);
        parameterAppendString += (split[key] + '&')
      }
    });
    parameterAppendString = parameterAppendString.substring(0, parameterAppendString.length - 1);

    $('.primary_utm_cta a').each(function() {
      var $this = $(this);       
      var _href = $this.attr('href'); 
      var _hash = _href.split('#');
      console.log(_hash, typeof _hash[1]);
      if (typeof _hash[1] != 'undefined'){
        $this.attr('href', _hash[0] + '?' + parameterAppendString + '#' + _hash[1]);
      } else {
        $this.attr('href', _href + '?' + parameterAppendString);
      }
    });
  },
  playVideoOnScroll() {
    const controller = new ScrollMagic.Controller();
    const blocks = $('.flexible-content--one-column-text-wide[data-play-on-scroll="yes"]').add('.flexible-content--two-column-text[data-play-on-scroll="yes"]');

    $(blocks).each(function (i, e) {
      const el = e;
      const video = $(el).find('.video')[0];

      if (video) {
        let played = false;
        let timer;
        let scrollPos = null;
        video.currentTime = 0.01;
        video.pause();

        new ScrollMagic.Scene({ triggerElement: e, duration: '100%', offset: 0, triggerHook: 'onEnter' })
          .on('update', function (event) {
            clearTimeout(timer);
            timer = setTimeout(function () {         
              const inView = event.scrollPos >= event.startPos && event.scrollPos <= event.endPos;
              if (scrollPos !== null && played === false && inView && Math.abs(scrollPos - event.scrollPos) > 50) {
                  video.play();
                  played = true;
              }
              scrollPos = event.scrollPos;
            }, 200);
          })
          .addTo(controller);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateLandingPage.js